'use client';

import { nativoAdManager, type NativoSlotRenderEvent, type NativoAdPlacementType } from '@benzinga/ads-utils';
import { useAdImpression, type useAdImpressionResult } from './useAdImpression';

interface UseNativoAdImpressionProps {
  placeholderClassName: string;
  placementType: NativoAdPlacementType;
}

export function useNativoAdImpression({
  placeholderClassName,
  placementType,
}: UseNativoAdImpressionProps): useAdImpressionResult<NativoSlotRenderEvent> {
  return useAdImpression<NativoSlotRenderEvent>({
    containerId: placeholderClassName,
    manager: nativoAdManager,
    partnerId: 'nativo',
    unitType: `nativo-${placementType}`,
  });
}
